import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from "@mui/material";
import { useAlerta } from "utils/alertas";

export default function EditarSemestreModal({ open, onClose, semestreId, onActualizado }) {
  const [nombre, setNombre] = useState("");
  const [numero, setNumero] = useState("");
  const token = sessionStorage.getItem("access_token");
  const { mostrarAlerta } = useAlerta();

  useEffect(() => {
    if (!semestreId) return;

    fetch(`${process.env.REACT_APP_API_URL}/semestre/${semestreId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then(res => res.json())
      .then(data => {
        setNombre(data.nombre || "");
        setNumero(data.numero || "");
      });
  }, [semestreId]);

  const handleUpdate = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/semestre/${semestreId}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ nombre,numero }),
      });

      if (!res.ok) throw new Error("Error al actualizar");
      mostrarAlerta("Semestre actualizado correctamente","success");
      onActualizado();
      onClose();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Editar Semestre/Año</DialogTitle>

      <DialogContent>
        <TextField
            fullWidth
            margin="normal"
            label="Número"
            name="numero"
            value={numero}
            onChange={(e) => setNumero(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button sx={{ color: "#fff" }} onClick={handleUpdate} variant="contained">Guardar</Button>
        <Button onClick={onClose} color="error">Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
}